import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ResearchFocus } from '../components/ResearchFocus';
import { AboutDirector } from '../components/AboutDirector';
import { ResearchApproach } from '../components/ResearchApproach';
import { VideoSection } from '../components/VideoSection';
import { StatsSection } from '../components/StatsSection';
import { Facilities } from '../components/Facilities';
import { Collaborators } from '../components/Collaborators';
import { NewsHighlights } from '../components/NewsHighlights';
import { JoinUs } from '../components/JoinUs';
export function Home() {
  return <>
      <HeroSection data-id="element-339" />
      <ResearchFocus data-id="element-340" />
      <AboutDirector data-id="element-341" />
      <ResearchApproach data-id="element-342" />
      <VideoSection data-id="element-343" />
      <StatsSection data-id="element-344" />
      <Facilities data-id="element-345" />
      <Collaborators data-id="element-346" />
      <NewsHighlights data-id="element-347" />
      <JoinUs data-id="element-348" />
    </>;
}